import { TenantType } from '@xeetr/types/enums'
import { BaseBookingModel } from '@xeetr/types/models'
import { DATE_FORMAT_LONGYEAR, DATE_FORMAT_SHORTYEAR } from '@xeetr/types/utils'
import { isEqual, startOfDay } from 'date-fns'
import { de } from 'date-fns/locale'
import { formatInTimeZone, toZonedTime } from 'date-fns-tz'

import { useTenant } from '../../../hooks/useTenant'
import { useWindowSize } from '../../../hooks/common/useWindowSize'

export const DateTimeColumn = (booking: BaseBookingModel) => {
  const { width } = useWindowSize()
  const { tenant } = useTenant()

  const timezone = tenant?.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC'
  const formattedDate = formatInTimeZone(
    booking.from,
    timezone,
    width > 425 ? DATE_FORMAT_LONGYEAR : DATE_FORMAT_SHORTYEAR
  )

  const zonedFrom = toZonedTime(booking.from, timezone)
  const fromTime = formatInTimeZone(zonedFrom, timezone, 'HH:mm', {
    locale: de,
  })

  if (booking.until) {
    const zonedUntil = toZonedTime(booking.until, timezone)
    const startOfFromDay = startOfDay(zonedFrom)
    const startOfUntilDay = startOfDay(zonedUntil)

    const startsAtMidnight = zonedFrom.getTime() === startOfFromDay.getTime()
    const endsAtMidnight = zonedUntil.getTime() === startOfUntilDay.getTime()

    if (startsAtMidnight && endsAtMidnight) {
      return `${formattedDate}, Ganzer Tag`
    }

    if (
      !isEqual(booking.from, booking.until) &&
      ((tenant?.type === TenantType.FOOD && tenant?.useLengthOfStay) ||
        tenant?.type === TenantType.SERVICE)
    ) {
      const untilTime = formatInTimeZone(zonedUntil, timezone, 'HH:mm', {
        locale: de,
      })
      return `${formattedDate}, ${fromTime} - ${untilTime}`
    }
  }

  return `${formattedDate}, ${fromTime}`
}
